import Vue from 'vue';
import Vuex from 'vuex';

import chartModule from './modules/chartModule';
import companyModule from './modules/companyModule';
import categoryModule from './modules/categoryModule';
import settingModule from './modules/settingModule';
import subcategoryModule from './modules/subcategoryModule';
import classModule from './modules/classModule';
import authenticationModule from './modules/authenticationModule';
import apiModule from './modules/apiModule';
import messageModule from './modules/messageModule';
import drugBrandModule from "./modules/drugBrandModule";
import tagModule from "./modules/tagModule";
import toolbarModule from "./modules/toolbarModule";
import finePrintModule from "./modules/finePrintModule";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        chart: chartModule,
        company: companyModule,
        category: categoryModule,
        setting: settingModule,
        subcategory: subcategoryModule,
        class: classModule,
        brand: drugBrandModule,
        tag: tagModule,
        authentication: authenticationModule,
        api: apiModule,
        message: messageModule,
        toolbar: toolbarModule,
        finePrint: finePrintModule
    },
});
